import React, { memo, useCallback, useMemo } from "react";
import { Autocomplete } from "@material-ui/lab";
import { makeStyles, TextField } from "@material-ui/core";
import Popper from "./Popper";
import CheckmarkIcon from "../icons/Checkmark";

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    input: {
      padding: 0,
    },
    option: {
      backgroundColor: "#fff",
    },
    menuOptionContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    },
    optionLable: {
      marginRight: pxToRem(10),
    },
  };
});

const CustomAutocomplete = ({
  options,
  onChange,
  label,
  variant,
  value,
  popperProps,
  disabled,
  groupBy,
  dataTestId,
  renderInput,
  placeholder,
  ...autocompleteProps
}) => {
  const style = useStyles();

  const handleChangeOption = useCallback(
    (e, newOption) => {
      onChange(newOption?.value);
    },
    [onChange]
  );

  const selectedOption = useMemo(
    () => options.find((option) => option.value === value) || null,
    [options, value]
  );

  const getOptionLabel = useCallback((option) => option.label, []);

  const CustomPopper = (defaultProps) =>
    useMemo(() => {
      const props = {
        ...popperProps,
        ...defaultProps,
      };
      return <Popper {...props} />;
    }, [defaultProps]);

  const handleRenderInput = useCallback(
    (params) =>
      renderInput ? (
        renderInput(params)
      ) : (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            className: style.input,
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
          }}
          label={label}
          placeholder={placeholder}
          variant={variant}
        />
      ),
    [label, variant, style, renderInput]
  );

  const renderOption = useCallback(
    ({ label, value }) => (
      <div className={style.menuOptionContainer} key={value}>
        <span className={style.optionLable}>{label}</span>
        {selectedOption && value === selectedOption.value && <CheckmarkIcon />}
      </div>
    ),
    [selectedOption, style]
  );

  return (
    <Autocomplete
      options={options}
      size="small"
      openOnFocus
      disabled={disabled}
      groupBy={groupBy}
      data-testid={dataTestId}
      PopperComponent={CustomPopper}
      value={selectedOption}
      getOptionLabel={getOptionLabel}
      onChange={handleChangeOption}
      renderInput={handleRenderInput}
      renderOption={renderOption}
      {...autocompleteProps}
    />
  );
};

export default memo(CustomAutocomplete);
